"use client"

import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useState } from "react"

const messages = [
  "Yol Altyapısı ve Trafik Güvenliği",
  "Trafik Mühendisliği ve Danışmanlığı",
  "Özel Çözümler",
  "Eğitim ve Akreditasyon"
]

const Hero: React.FC = () => {
  const [index, setIndex] = useState(0)
  const [isHovered, setIsHovered] = useState(false)

  useEffect(() => {
    if (isHovered) return

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % messages.length)
    }, 4000)

    return () => clearInterval(interval)
  }, [isHovered])

  return (
      <section className='!py-0' id="hero">
        <div className='bg-gradient-to-b from-[#E89C25] via-[#e39c2d] dark:via-[#E89C25] to-white/10 dark:to-black/10 overflow-hidden relative'>
          <div className='container max-w-8xl mx-auto px-5 2xl:px-0 pt-32 md:pt-60 md:pb-68'>
            <div className='relative text-white dark:text-dark text-center md:text-start z-10'>
              <h1
                  className='text-inherit text-5xl sm:text-7xl font-semibold -tracking-wider md:max-w-45p mt-4 mb-6 h-[500px] flex items-center justify-center md:justify-start'
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
              >
                <Link
                    href="/#activities"
                    className='transition-opacity duration-700 ease-in-out opacity-0 animate-fade-in-up inline-block hover:underline'
                >
                  {messages[index]}
                </Link>
              </h1>


              <div className='flex flex-col xs:flex-row justify-center md:justify-start gap-4 mt-4'>
                <Link
                    href="/contactus"
                    className='px-8 py-4 bg-white dark:bg-dark text-dark dark:text-white font-semibold rounded-full duration-300 hover:bg-[#E89C25] hover:text-white dark:hover:text-dark hover:scale-105 shadow-md transition-transform'
                >
                  Bize Ulaşın
                </Link>
              </div>
            </div>

            <div className='hidden md:block absolute -top-2 -right-15'>
              <Image
                  src={'/images/hero/heroBanner.webp'}
                  alt='heroImg'
                  width={1024}
                  height={1018}
                  priority={false}
                  unoptimized={true}
                  className="scale-x-[-1]"
              />
            </div>
          </div>
        </div>
      </section>
  )
}

export default Hero
